// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1Y60a","select":"Header_select__2PbHQ","clinic":"Header_clinic__VrQZM"};